import { render, staticRenderFns } from "./CheckoutPaymentType.vue?vue&type=template&id=4afe4b8c&scoped=true"
import script from "./CheckoutPaymentType.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentType.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPaymentType.vue?vue&type=style&index=0&id=4afe4b8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe4b8c",
  null
  
)

export default component.exports